<template>
    <div class="detailed-list-list detailed-list">
        <div class="header-title">
            选择清单
        </div>
        <div class="list-cont">
            <div class="row">
                <div class="col list-oper">
                    <button class="green-btn"  @click="goCreate">
                        <i style="margin-right: 0px;" class="iconfont icon-plus"></i>
                    </button>
                </div>
                <div class="col list-name list-name-search" >
                    <detail-search @search="searchHandle"></detail-search>
                </div>
                <div class="col list-type">
                    清单类型
                </div>
                <div class="col list-update-time">
                    创建时间
                </div>
                <!--<div class="col list-plan">-->
                    <!--所属场景-->
                <!--</div>-->
            </div>
            <router-link tag="div" class="row cursor list-row" v-for="(item,index) in detailedLists" :key="item.id"
                         :to="{'name':'detailedListOperate',query:{'id':item.id}}" v-if="item.mode===1 && item.quotedNum">
                <!--v-if="item.mode==1||item.quotedNum"-->
                <div class="col frist-img" style="overflow: inherit;">
                    <div class="img">
                        <img v-if="item.detailedListCoverFiles" :src="imgBaseUrl + item.detailedListCoverFiles[0].key" alt="">
                        <div class="num">
                            {{item.num}}件
                        </div>
                    </div>
                </div>
                <div class="col list-name">
                    <div class="textCon">
                        <p>{{item.name}}</p>
                    </div>
                </div>
                <div class="col list-type">
                    <div v-if="item.mode === 1" class="lisType" style="text-align: center;">
                        {{item.modeDisplay}}
                    </div>
                    <div v-else class="lisType" style="text-align: center;background: #F4D03C">
                        {{item.modeDisplay}}
                    </div>
                </div>
                <div class="col list-update-time">
                    <div style="width:70px;text-align: center">
                        <p>{{item.createTime|setTimeDate}}</p>
                        <p>{{item.createTime|setTime}}</p>
                    </div>
                </div>
                <div class="col list-plan">
                    <div style="width:108px">
                        <!--{{item.planName||'不属于任何场景'}}-->
                    </div>
                </div>
                <div class="col list-del">
                    <i class="iconfont icon-trash" style="font-size:13px;" @click="remove($event,item.id,index)"></i>
                </div>
            </router-link>
        </div>
        <div v-if="!detailedLists.length&&!busy && !searchDetailList" class="no-result bg-grey">
            <img src="../../../images/cut/detailedlist_null.png">
            <p>你的清单会在这里显示</p>
        </div>
        <div v-if="!detailedLists.length&&!busy && searchDetailList" class="no-result bg-grey">
            <img src="../../../images/cut/search_no_result.png">
            <p>没有相关数据</p>
        </div>
        <delete-confirm ref="deleteConfirm" @confirm="removeList"></delete-confirm>
        <loading v-if="busy" style="margin-top:60px;padding-bottom:80px;"></loading>
    </div>
</template>
<style scoped>
    .header-title{
        padding:30px 0 60px;
        font-size:24px;
        color:#308697;
    }
    .list-cont{
        width:1200px;
        margin:0 auto;
    }
    .list-oper button{
        width:40px;
        height:40px;
        text-align: center;
        line-height:40px;
        border-radius: 4px;
    }
    .detailed-list .row .col{
        width: 60px;
    }
    .list-oper button .iconfont{
        font-size:18px;
    }
    .row{
        margin-bottom:17px;
    }
    .row .col{
        padding:0;
    }
    .row .col:first-child{
        margin-left:0;
    }
    .list-row{
        margin-bottom:8px;
        background: #fff;
        border: 1px solid #DCE0E0;
        height:66px;
        line-height:66px;
    }
    .list-row:last-child{
        margin-bottom: 80px;
    }
    .list-row:hover{
        background: #F7F9FA;
    }
    .list-row .list-oper:first-child{
        /*margin-top:17px;*/
    }
    .frist-img .img{
        position: relative;
        display: inline-block;
        float: left;
        width: 66px;
        height: 64px;
        overflow: hidden;
        background: #F7F9FA;
        margin-top: -3px;
    }
    .frist-img .img .num{
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        height: 18px;
        line-height: 18px;
        text-align: center;
        color:#fff;
        background: #308697;
        font-size: 12px;
    }
    .frist-img .img img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .list-row .col{
        font-size:12px;
        color:#353838;
    }
    .list-row .col>div{
        display:inline-block;
        line-height:18px;
    }
    /*.row .col.list-oper{*/
    /*width:196px;*/
    /*}*/
    /*.list-row .col.list-oper{*/
    /*width:156px;*/
    /*}*/
    .row .col.list-name{
        width:444px;
        text-align: center;
    }
    .row .col.list-name .textCon{
        width: 236px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .row .col.list-name-search{
        width: 444px;
    }
    .row .col.list-type{
        width:190px;
    }
    .row .col.list-type .lisType{
        padding: 2px 13px;
        background: #99C72C;
        border-radius: 2px;
        color:#fff;
    }
    .row .col.list-update-time{
        width:230px;
    }
    .row .col.list-plan{
        width:220px;
    }
    .row .col.list-del{
        width:52px;
    }
    .row .col.list-del i:hover{
        color:#308697;
    }
</style>
<script>
    import api from '../../../api'
    import detailSearch from './detailedSearch.vue'
    import loading from '../../common/loading'
    import deleteConfirm from '../../common/deleteConfirm.vue'
    export default{
        data(){
            return {
                detailedLists: [],
                total:0,
                filter:{
                    pageNum:1,
                    pageSize:20,
                    name: ''
                },
                busy:false,
                imgBaseUrl: api.common.imgBaseUrl,
                searchDetailList: false
            }
        },
        methods:{
            goCreate(){
                this.$router.push({name:'detailedListOperate'});
            },
            updateList(){
                this.busy = true;
                api.detailedLists.getDetailedLists(this.filter)
                    .then((res)=>{
                        this.busy = false;
                        this.detailedLists = this.detailedLists.concat(res.list);
                    },()=>{
                        this.busy = false;
                    });
            },
            loadMore: function () {
                if (this.filter.pageNum * this.filter.pageSize < this.total) {
                    this.filter.pageNum++;
                    this.updateList(this.filter);
                }
            },
            isLoadMore(){
                let scrolltop = window.pageYOffset||document.body.scrollTop||document.documentElement.scrollTop;
                let documentHeight = document.body.scrollHeight;
                let winHeight = window.innerHeight;
                if(documentHeight-scrolltop<2*winHeight-230&&!this.busy){
                    this.loadMore();
                }
            },
            remove(e,id,index){
                e.stopPropagation();
                this.$refs.deleteConfirm.open({
                    id:id,
                    index:index
                });
            },
            removeList(params){
                api.detailedLists.deleteDetailedList(params.id)
                    .then(()=>{
                        this.$Message.success('删除成功');
                        this.detailedLists.splice(params.index,1);
                    });
            },
            searchHandle(word) { //搜索
                this.filter.name = word
                api.detailedLists.getDetailedLists(this.filter)
                    .then((res)=>{
                        this.busy = false;
                        this.detailedLists = res.list;
                        this.searchDetailList = true
                    },()=>{
                        this.busy = false;
                    });
            }
        },
        components:{
            loading,
            deleteConfirm,
            detailSearch
        },
        created(){
            this.updateList();
        },
        beforeMount(){
            window.addEventListener('scroll',this.isLoadMore);
        },
        beforeDestroy(){
            window.removeEventListener('scroll',this.isLoadMore);
        }
    }
</script>